module.exports = __webpack_public_path__ + "img/kinetic_25.1fd710c4.png";